import { render } from "./ChatWidget.vue?vue&type=template&id=553f5422&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"

import "./ChatWidget.vue?vue&type=style&index=0&id=553f5422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553f5422"]])

export default __exports__